export default __webpack_public_path__ + "static/media/bexio-landing-bg.058ac2c0.svg";